export default __webpack_public_path__ + "static/media/info-image.5ae9d1dc.png";